import { useState, useEffect } from 'react';

import ClientsForOwnerModel from './ClientsForOwnerModel';

export default function useFirstClientForUser(user) {
    const { uid, isAnonymous } = user || {};
    const [client, setClient] = useState(null);

    const getClients = async (ownerId) => {
        const clientsModel = new ClientsForOwnerModel({ ownerId });
        const clients = await clientsModel.get();
        return clients;
    };

    useEffect(() => {
        const fetchClient = async () => {
            console.log('Fetching clients...');
            if (!isAnonymous && uid) {
                const clients = await getClients(uid);
                console.log('Clients fetched:', clients);
                if (clients.length > 0) {
                    setClient(clients[0]); // Set the first client
                } else {
                    setClient(null); // No clients found
                }
            } else {
                setClient(null); // User is anonymous or no UID
            }
        };

        fetchClient();
    }, [uid, isAnonymous]); // Re-run if `uid` or `isAnonymous` changes

    return client; // Return the found client
}
